module.exports = __webpack_public_path__ + "img/modal-alert-code.4a1b0c28.png";